module.exports = __webpack_public_path__ + "static/media/menopause.5b9ee5d7.png";